import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import useCollection from "collections/hooks/useCollection";
import { Spinner, IconButton, ConfirmDialog, Link } from "components/common";
import CollectionsRoutes from "../../Routes";
const ActionTd = styled.td(
  ({ theme }) => css`
    && {
      display: flex;
      justify-content: flex-end;
      padding-right: ${theme.spacings.sm};
    }
  `
);
const EntityCollectionItem = ({ item, onDeleteItem }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { isLoading, data: collection } = useCollection(item.name);
  const toggleShowConfirmDelete = () => {
    setShowConfirmDelete(!showConfirmDelete);
  };
  const handleDelete = () => onDeleteItem(item);
  const deleteButton = typeof onDeleteItem === "function" ? /* @__PURE__ */ React.createElement(IconButton, { onClick: () => setShowConfirmDelete(true), name: "close", title: `Remove ${collection == null ? void 0 : collection.title}` }) : null;
  if (isLoading) {
    /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: CollectionsRoutes.show(collection == null ? void 0 : collection.id) }, collection == null ? void 0 : collection.title)), /* @__PURE__ */ React.createElement("td", null, collection == null ? void 0 : collection.description), deleteButton && /* @__PURE__ */ React.createElement(ActionTd, null, deleteButton, " ", showConfirmDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmDelete,
      onConfirm: handleDelete,
      onCancel: toggleShowConfirmDelete,
      title: "Are you sure?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "You are about to remove this collection from the list of collections that will be assigned to entity created by users."), /* @__PURE__ */ React.createElement("p", null, "Do you wish to continue?"))
  )));
};
export default EntityCollectionItem;
